import React from 'react'

export default function Oracle() {
  return (
    <>
        <h1>Szia!!!!!!</h1>
    </>
  )
}